module.exports = __webpack_public_path__ + "8c50a62baf044c0b98b4009d57197beb.MP3";